import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { SummaryConfigurationSettings } from "@/Patient/Models/Settings/SummaryConfigurationSettings";

export class MedicalSummaryConfigurationActions extends AsyncAction {
    private static readonly actions = new MedicalSummaryConfigurationActions();

    public static async save(summaryConfigurationSettings: SummaryConfigurationSettings, userId: string): Promise<void> {
        await this.actions.postAsync(
            ServerOperations.Server.Myle_Patient_MedicalSummary_UpdateSummaryConfiguration,
            {
                SummaryConfigurationSettings: summaryConfigurationSettings,
                UserId: userId
            }
        );
    }
}
